export default [
  {
    'nombre': 'México',
    'iso2': 'MX',
    'iso3': 'MEX',
    'phone_code': '52'
  },
  {
    'nombre': 'Afganistán',
    'iso2': 'AF',
    'iso3': 'AFG',
    'phone_code': '93'
  },
  {
    'nombre': 'Albania',
    'iso2': 'AL',
    'iso3': 'ALB',
    'phone_code': '355'
  },
  {
    'nombre': 'Alemania',
    'iso2': 'DE',
    'iso3': 'DEU',
    'phone_code': '49'
  },
  {
    'nombre': 'Algeria',
    'iso2': 'DZ',
    'iso3': 'DZA',
    'phone_code': '213'
  },
  {
    'nombre': 'Andorra',
    'iso2': 'AD',
    'iso3': 'AND',
    'phone_code': '376'
  },
  {
    'nombre': 'Angola',
    'iso2': 'AO',
    'iso3': 'AGO',
    'phone_code': '244'
  },
  {
    'nombre': 'Anguila',
    'iso2': 'AI',
    'iso3': 'AIA',
    'phone_code': '1264'
  },
  {
    'nombre': 'Antártida',
    'iso2': 'AQ',
    'iso3': 'ATA',
    'phone_code': '672'
  },
  {
    'nombre': 'Antigua y Barbuda',
    'iso2': 'AG',
    'iso3': 'ATG',
    'phone_code': '1268'
  },
  {
    'nombre': 'Arabia Saudita',
    'iso2': 'SA',
    'iso3': 'SAU',
    'phone_code': '966'
  },
  {
    'nombre': 'Argentina',
    'iso2': 'AR',
    'iso3': 'ARG',
    'phone_code': '54'
  },
  {
    'nombre': 'Armenia',
    'iso2': 'AM',
    'iso3': 'ARM',
    'phone_code': '374'
  },
  {
    'nombre': 'Aruba',
    'iso2': 'AW',
    'iso3': 'ABW',
    'phone_code': '297'
  },
  {
    'nombre': 'Australia',
    'iso2': 'AU',
    'iso3': 'AUS',
    'phone_code': '61'
  },
  {
    'nombre': 'Austria',
    'iso2': 'AT',
    'iso3': 'AUT',
    'phone_code': '43'
  },
  {
    'nombre': 'Azerbayán',
    'iso2': 'AZ',
    'iso3': 'AZE',
    'phone_code': '994'
  },
  {
    'nombre': 'Bélgica',
    'iso2': 'BE',
    'iso3': 'BEL',
    'phone_code': '32'
  },
  {
    'nombre': 'Bahamas',
    'iso2': 'BS',
    'iso3': 'BHS',
    'phone_code': '1 242'
  },
  {
    'nombre': 'Bahrein',
    'iso2': 'BH',
    'iso3': 'BHR',
    'phone_code': '973'
  },
  {
    'nombre': 'Bangladesh',
    'iso2': 'BD',
    'iso3': 'BGD',
    'phone_code': '880'
  },
  {
    'nombre': 'Barbados',
    'iso2': 'BB',
    'iso3': 'BRB',
    'phone_code': '1 246'
  },
  {
    'nombre': 'Belice',
    'iso2': 'BZ',
    'iso3': 'BLZ',
    'phone_code': '501'
  },
  {
    'nombre': 'Benín',
    'iso2': 'BJ',
    'iso3': 'BEN',
    'phone_code': '229'
  },
  {
    'nombre': 'Bhután',
    'iso2': 'BT',
    'iso3': 'BTN',
    'phone_code': '975'
  },
  {
    'nombre': 'Bielorrusia',
    'iso2': 'BY',
    'iso3': 'BLR',
    'phone_code': '375'
  },
  {
    'nombre': 'Birmania',
    'iso2': 'MM',
    'iso3': 'MMR',
    'phone_code': '95'
  },
  {
    'nombre': 'Bolivia',
    'iso2': 'BO',
    'iso3': 'BOL',
    'phone_code': '591'
  },
  {
    'nombre': 'Bosnia y Herzegovina',
    'iso2': 'BA',
    'iso3': 'BIH',
    'phone_code': '387'
  },
  {
    'nombre': 'Botsuana',
    'iso2': 'BW',
    'iso3': 'BWA',
    'phone_code': '267'
  },
  {
    'nombre': 'Brasil',
    'iso2': 'BR',
    'iso3': 'BRA',
    'phone_code': '55'
  },
  {
    'nombre': 'Brunéi',
    'iso2': 'BN',
    'iso3': 'BRN',
    'phone_code': '673'
  },
  {
    'nombre': 'Bulgaria',
    'iso2': 'BG',
    'iso3': 'BGR',
    'phone_code': '359'
  },
  {
    'nombre': 'Burkina Faso',
    'iso2': 'BF',
    'iso3': 'BFA',
    'phone_code': '226'
  },
  {
    'nombre': 'Burundi',
    'iso2': 'BI',
    'iso3': 'BDI',
    'phone_code': '257'
  },
  {
    'nombre': 'Cabo Verde',
    'iso2': 'CV',
    'iso3': 'CPV',
    'phone_code': '238'
  },
  {
    'nombre': 'Camboya',
    'iso2': 'KH',
    'iso3': 'KHM',
    'phone_code': '855'
  },
  {
    'nombre': 'Camerún',
    'iso2': 'CM',
    'iso3': 'CMR',
    'phone_code': '237'
  },
  {
    'nombre': 'Chad',
    'iso2': 'TD',
    'iso3': 'TCD',
    'phone_code': '235'
  },
  {
    'nombre': 'Chile',
    'iso2': 'CL',
    'iso3': 'CHL',
    'phone_code': '56'
  },
  {
    'nombre': 'China',
    'iso2': 'CN',
    'iso3': 'CHN',
    'phone_code': '86'
  },
  {
    'nombre': 'Chipre',
    'iso2': 'CY',
    'iso3': 'CYP',
    'phone_code': '357'
  },
  {
    'nombre': 'Colombia',
    'iso2': 'CO',
    'iso3': 'COL',
    'phone_code': '57'
  },
  {
    'nombre': 'Comoras',
    'iso2': 'KM',
    'iso3': 'COM',
    'phone_code': '269'
  },
  {
    'nombre': 'Congo',
    'iso2': 'CG',
    'iso3': 'COG',
    'phone_code': '242'
  },
  {
    'nombre': 'Congo',
    'iso2': 'CD',
    'iso3': 'COD',
    'phone_code': '243'
  },
  {
    'nombre': 'Corea del Norte',
    'iso2': 'KP',
    'iso3': 'PRK',
    'phone_code': '850'
  },
  {
    'nombre': 'Corea del Sur',
    'iso2': 'KR',
    'iso3': 'KOR',
    'phone_code': '82'
  },
  {
    'nombre': 'Costa de Marfil',
    'iso2': 'CI',
    'iso3': 'CIV',
    'phone_code': '225'
  },
  {
    'nombre': 'Costa Rica',
    'iso2': 'CR',
    'iso3': 'CRI',
    'phone_code': '506'
  },
  {
    'nombre': 'Croacia',
    'iso2': 'HR',
    'iso3': 'HRV',
    'phone_code': '385'
  },
  {
    'nombre': 'Cuba',
    'iso2': 'CU',
    'iso3': 'CUB',
    'phone_code': '53'
  },
  {
    'nombre': 'Dinamarca',
    'iso2': 'DK',
    'iso3': 'DNK',
    'phone_code': '45'
  },
  {
    'nombre': 'Dominica',
    'iso2': 'DM',
    'iso3': 'DMA',
    'phone_code': '1 767'
  },
  {
    'nombre': 'Ecuador',
    'iso2': 'EC',
    'iso3': 'ECU',
    'phone_code': '593'
  },
  {
    'nombre': 'Egipto',
    'iso2': 'EG',
    'iso3': 'EGY',
    'phone_code': '20'
  },
  {
    'nombre': 'El Salvador',
    'iso2': 'SV',
    'iso3': 'SLV',
    'phone_code': '503'
  },
  {
    'nombre': 'Emiratos Árabes Unidos',
    'iso2': 'AE',
    'iso3': 'ARE',
    'phone_code': '971'
  },
  {
    'nombre': 'Eritrea',
    'iso2': 'ER',
    'iso3': 'ERI',
    'phone_code': '291'
  },
  {
    'nombre': 'Eslovaquia',
    'iso2': 'SK',
    'iso3': 'SVK',
    'phone_code': '421'
  },
  {
    'nombre': 'Eslovenia',
    'iso2': 'SI',
    'iso3': 'SVN',
    'phone_code': '386'
  },
  {
    'nombre': 'España',
    'iso2': 'ES',
    'iso3': 'ESP',
    'phone_code': '34'
  },
  {
    'nombre': 'Estados Unidos, Canadá, Puerto Rico',
    'iso2': 'US',
    'iso3': 'USA',
    'phone_code': '1'
  },
  {
    'nombre': 'Estonia',
    'iso2': 'EE',
    'iso3': 'EST',
    'phone_code': '372'
  },
  {
    'nombre': 'Etiopía',
    'iso2': 'ET',
    'iso3': 'ETH',
    'phone_code': '251'
  },
  {
    'nombre': 'Filipinas',
    'iso2': 'PH',
    'iso3': 'PHL',
    'phone_code': '63'
  },
  {
    'nombre': 'Finlandia',
    'iso2': 'FI',
    'iso3': 'FIN',
    'phone_code': '358'
  },
  {
    'nombre': 'Fiyi',
    'iso2': 'FJ',
    'iso3': 'FJI',
    'phone_code': '679'
  },
  {
    'nombre': 'Francia',
    'iso2': 'FR',
    'iso3': 'FRA',
    'phone_code': '33'
  },
  {
    'nombre': 'Gabón',
    'iso2': 'GA',
    'iso3': 'GAB',
    'phone_code': '241'
  },
  {
    'nombre': 'Gambia',
    'iso2': 'GM',
    'iso3': 'GMB',
    'phone_code': '220'
  },
  {
    'nombre': 'Georgia',
    'iso2': 'GE',
    'iso3': 'GEO',
    'phone_code': '995'
  },
  {
    'nombre': 'Ghana',
    'iso2': 'GH',
    'iso3': 'GHA',
    'phone_code': '233'
  },
  {
    'nombre': 'Gibraltar',
    'iso2': 'GI',
    'iso3': 'GIB',
    'phone_code': '350'
  },
  {
    'nombre': 'Granada',
    'iso2': 'GD',
    'iso3': 'GRD',
    'phone_code': '1473'
  },
  {
    'nombre': 'Grecia',
    'iso2': 'GR',
    'iso3': 'GRC',
    'phone_code': '30'
  },
  {
    'nombre': 'Groenlandia',
    'iso2': 'GL',
    'iso3': 'GRL',
    'phone_code': '299'
  },
  {
    'nombre': 'Guam',
    'iso2': 'GU',
    'iso3': 'GUM',
    'phone_code': '1671'
  },
  {
    'nombre': 'Guatemala',
    'iso2': 'GT',
    'iso3': 'GTM',
    'phone_code': '502'
  },
  {
    'nombre': 'Guayana Francesa',
    'iso2': 'GF',
    'iso3': 'GUF',
    'phone_code': ''
  },
  {
    'nombre': 'Guinea',
    'iso2': 'GN',
    'iso3': 'GIN',
    'phone_code': '224'
  },
  {
    'nombre': 'Guinea Ecuatorial',
    'iso2': 'GQ',
    'iso3': 'GNQ',
    'phone_code': '240'
  },
  {
    'nombre': 'Guinea-Bissau',
    'iso2': 'GW',
    'iso3': 'GNB',
    'phone_code': '245'
  },
  {
    'nombre': 'Guyana',
    'iso2': 'GY',
    'iso3': 'GUY',
    'phone_code': '592'
  },
  {
    'nombre': 'Haití',
    'iso2': 'HT',
    'iso3': 'HTI',
    'phone_code': '509'
  },
  {
    'nombre': 'Honduras',
    'iso2': 'HN',
    'iso3': 'HND',
    'phone_code': '504'
  },
  {
    'nombre': 'Hong kong',
    'iso2': 'HK',
    'iso3': 'HKG',
    'phone_code': '852'
  },
  {
    'nombre': 'Hungría',
    'iso2': 'HU',
    'iso3': 'HUN',
    'phone_code': '36'
  },
  {
    'nombre': 'India',
    'iso2': 'IN',
    'iso3': 'IND',
    'phone_code': '91'
  },
  {
    'nombre': 'Indonesia',
    'iso2': 'ID',
    'iso3': 'IDN',
    'phone_code': '62'
  },
  {
    'nombre': 'Irán',
    'iso2': 'IR',
    'iso3': 'IRN',
    'phone_code': '98'
  },
  {
    'nombre': 'Irak',
    'iso2': 'IQ',
    'iso3': 'IRQ',
    'phone_code': '964'
  },
  {
    'nombre': 'Irlanda',
    'iso2': 'IE',
    'iso3': 'IRL',
    'phone_code': '353'
  },
  {
    'nombre': 'Israel',
    'iso2': 'IL',
    'iso3': 'ISR',
    'phone_code': '972'
  },
  {
    'nombre': 'Italia',
    'iso2': 'IT',
    'iso3': 'ITA',
    'phone_code': '39'
  },
  {
    'nombre': 'Jamaica',
    'iso2': 'JM',
    'iso3': 'JAM',
    'phone_code': '1876'
  },
  {
    'nombre': 'Japón',
    'iso2': 'JP',
    'iso3': 'JPN',
    'phone_code': '81'
  },
  {
    'nombre': 'Jersey',
    'iso2': 'JE',
    'iso3': 'JEY',
    'phone_code': ''
  },
  {
    'nombre': 'Jordania',
    'iso2': 'JO',
    'iso3': 'JOR',
    'phone_code': '962'
  },
  {
    'nombre': 'Kazajistán',
    'iso2': 'KZ',
    'iso3': 'KAZ',
    'phone_code': '7'
  },
  {
    'nombre': 'Kenia',
    'iso2': 'KE',
    'iso3': 'KEN',
    'phone_code': '254'
  },
  {
    'nombre': 'Kirgizstán',
    'iso2': 'KG',
    'iso3': 'KGZ',
    'phone_code': '996'
  },
  {
    'nombre': 'Kiribati',
    'iso2': 'KI',
    'iso3': 'KIR',
    'phone_code': '686'
  },
  {
    'nombre': 'Kuwait',
    'iso2': 'KW',
    'iso3': 'KWT',
    'phone_code': '965'
  },
  {
    'nombre': 'Líbano',
    'iso2': 'LB',
    'iso3': 'LBN',
    'phone_code': '961'
  },
  {
    'nombre': 'Laos',
    'iso2': 'LA',
    'iso3': 'LAO',
    'phone_code': '856'
  },
  {
    'nombre': 'Lesoto',
    'iso2': 'LS',
    'iso3': 'LSO',
    'phone_code': '266'
  },
  {
    'nombre': 'Letonia',
    'iso2': 'LV',
    'iso3': 'LVA',
    'phone_code': '371'
  },
  {
    'nombre': 'Liberia',
    'iso2': 'LR',
    'iso3': 'LBR',
    'phone_code': '231'
  },
  {
    'nombre': 'Libia',
    'iso2': 'LY',
    'iso3': 'LBY',
    'phone_code': '218'
  },
  {
    'nombre': 'Liechtenstein',
    'iso2': 'LI',
    'iso3': 'LIE',
    'phone_code': '423'
  },
  {
    'nombre': 'Lituania',
    'iso2': 'LT',
    'iso3': 'LTU',
    'phone_code': '370'
  },
  {
    'nombre': 'Luxemburgo',
    'iso2': 'LU',
    'iso3': 'LUX',
    'phone_code': '352'
  },
  {
    'nombre': 'México',
    'iso2': 'MX',
    'iso3': 'MEX',
    'phone_code': '52'
  },
  {
    'nombre': 'Mónaco',
    'iso2': 'MC',
    'iso3': 'MCO',
    'phone_code': '377'
  },
  {
    'nombre': 'Macao',
    'iso2': 'MO',
    'iso3': 'MAC',
    'phone_code': '853'
  },
  {
    'nombre': 'Macedônia',
    'iso2': 'MK',
    'iso3': 'MKD',
    'phone_code': '389'
  },
  {
    'nombre': 'Madagascar',
    'iso2': 'MG',
    'iso3': 'MDG',
    'phone_code': '261'
  },
  {
    'nombre': 'Malasia',
    'iso2': 'MY',
    'iso3': 'MYS',
    'phone_code': '60'
  },
  {
    'nombre': 'Malawi',
    'iso2': 'MW',
    'iso3': 'MWI',
    'phone_code': '265'
  },
  {
    'nombre': 'Mali',
    'iso2': 'ML',
    'iso3': 'MLI',
    'phone_code': '223'
  },
  {
    'nombre': 'Malta',
    'iso2': 'MT',
    'iso3': 'MLT',
    'phone_code': '356'
  },
  {
    'nombre': 'Marruecos',
    'iso2': 'MA',
    'iso3': 'MAR',
    'phone_code': '212'
  },
  {
    'nombre': 'Martinica',
    'iso2': 'MQ',
    'iso3': 'MTQ',
    'phone_code': ''
  },
  {
    'nombre': 'Mauricio',
    'iso2': 'MU',
    'iso3': 'MUS',
    'phone_code': '230'
  },
  {
    'nombre': 'Mauritania',
    'iso2': 'MR',
    'iso3': 'MRT',
    'phone_code': '222'
  },
  {
    'nombre': 'Mayotte',
    'iso2': 'YT',
    'iso3': 'MYT',
    'phone_code': '262'
  },
  {
    'nombre': 'Micronesia',
    'iso2': 'FM',
    'iso3': 'FSM',
    'phone_code': '691'
  },
  {
    'nombre': 'Moldavia',
    'iso2': 'MD',
    'iso3': 'MDA',
    'phone_code': '373'
  },
  {
    'nombre': 'Mongolia',
    'iso2': 'MN',
    'iso3': 'MNG',
    'phone_code': '976'
  },
  {
    'nombre': 'Montenegro',
    'iso2': 'ME',
    'iso3': 'MNE',
    'phone_code': '382'
  },
  {
    'nombre': 'Montserrat',
    'iso2': 'MS',
    'iso3': 'MSR',
    'phone_code': '1 664'
  },
  {
    'nombre': 'Mozambique',
    'iso2': 'MZ',
    'iso3': 'MOZ',
    'phone_code': '258'
  },
  {
    'nombre': 'Namibia',
    'iso2': 'NA',
    'iso3': 'NAM',
    'phone_code': '264'
  },
  {
    'nombre': 'Nauru',
    'iso2': 'NR',
    'iso3': 'NRU',
    'phone_code': '674'
  },
  {
    'nombre': 'Nepal',
    'iso2': 'NP',
    'iso3': 'NPL',
    'phone_code': '977'
  },
  {
    'nombre': 'Nicaragua',
    'iso2': 'NI',
    'iso3': 'NIC',
    'phone_code': '505'
  },
  {
    'nombre': 'Niger',
    'iso2': 'NE',
    'iso3': 'NER',
    'phone_code': '227'
  },
  {
    'nombre': 'Nigeria',
    'iso2': 'NG',
    'iso3': 'NGA',
    'phone_code': '234'
  },
  {
    'nombre': 'Niue',
    'iso2': 'NU',
    'iso3': 'NIU',
    'phone_code': '683'
  },
  {
    'nombre': 'Noruega',
    'iso2': 'NO',
    'iso3': 'NOR',
    'phone_code': '47'
  },
  {
    'nombre': 'Nueva Caledonia',
    'iso2': 'NC',
    'iso3': 'NCL',
    'phone_code': '687'
  },
  {
    'nombre': 'Nueva Zelanda',
    'iso2': 'NZ',
    'iso3': 'NZL',
    'phone_code': '64'
  },
  {
    'nombre': 'Omán',
    'iso2': 'OM',
    'iso3': 'OMN',
    'phone_code': '968'
  },
  {
    'nombre': 'Países Bajos',
    'iso2': 'NL',
    'iso3': 'NLD',
    'phone_code': '31'
  },
  {
    'nombre': 'Pakistán',
    'iso2': 'PK',
    'iso3': 'PAK',
    'phone_code': '92'
  },
  {
    'nombre': 'Palau',
    'iso2': 'PW',
    'iso3': 'PLW',
    'phone_code': '680'
  },
  {
    'nombre': 'Palestina',
    'iso2': 'PS',
    'iso3': 'PSE',
    'phone_code': ''
  },
  {
    'nombre': 'Panamá',
    'iso2': 'PA',
    'iso3': 'PAN',
    'phone_code': '507'
  },
  {
    'nombre': 'Papúa Nueva Guinea',
    'iso2': 'PG',
    'iso3': 'PNG',
    'phone_code': '675'
  },
  {
    'nombre': 'Paraguay',
    'iso2': 'PY',
    'iso3': 'PRY',
    'phone_code': '595'
  },
  {
    'nombre': 'Perú',
    'iso2': 'PE',
    'iso3': 'PER',
    'phone_code': '51'
  },
  {
    'nombre': 'Polinesia Francesa',
    'iso2': 'PF',
    'iso3': 'PYF',
    'phone_code': '689'
  },
  {
    'nombre': 'Polonia',
    'iso2': 'PL',
    'iso3': 'POL',
    'phone_code': '48'
  },
  {
    'nombre': 'Portugal',
    'iso2': 'PT',
    'iso3': 'PRT',
    'phone_code': '351'
  },
  {
    'nombre': 'Qatar',
    'iso2': 'QA',
    'iso3': 'QAT',
    'phone_code': '974'
  },
  {
    'nombre': 'Reino Unido',
    'iso2': 'GB',
    'iso3': 'GBR',
    'phone_code': '44'
  },
  {
    'nombre': 'República Centroafricana',
    'iso2': 'CF',
    'iso3': 'CAF',
    'phone_code': '236'
  },
  {
    'nombre': 'República Checa',
    'iso2': 'CZ',
    'iso3': 'CZE',
    'phone_code': '420'
  },
  {
    'nombre': 'República Dominicana',
    'iso2': 'DO',
    'iso3': 'DOM',
    'phone_code': '1 809'
  },
  {
    'nombre': 'Reunión',
    'iso2': 'RE',
    'iso3': 'REU',
    'phone_code': ''
  },
  {
    'nombre': 'Ruanda',
    'iso2': 'RW',
    'iso3': 'RWA',
    'phone_code': '250'
  },
  {
    'nombre': 'Rumanía',
    'iso2': 'RO',
    'iso3': 'ROU',
    'phone_code': '40'
  },
  {
    'nombre': 'Rusia',
    'iso2': 'RU',
    'iso3': 'RUS',
    'phone_code': '7'
  },
  {
    'nombre': 'Sahara Occidental',
    'iso2': 'EH',
    'iso3': 'ESH',
    'phone_code': ''
  },
  {
    'nombre': 'Samoa',
    'iso2': 'WS',
    'iso3': 'WSM',
    'phone_code': '685'
  },
  {
    'nombre': 'Samoa Americana',
    'iso2': 'AS',
    'iso3': 'ASM',
    'phone_code': '1 684'
  },
  {
    'nombre': 'San Bartolomé',
    'iso2': 'BL',
    'iso3': 'BLM',
    'phone_code': '590'
  },
  {
    'nombre': 'San Cristóbal y Nieves',
    'iso2': 'KN',
    'iso3': 'KNA',
    'phone_code': '1 869'
  },
  {
    'nombre': 'San Marino',
    'iso2': 'SM',
    'iso3': 'SMR',
    'phone_code': '378'
  },
  {
    'nombre': 'San Martín (Francia)',
    'iso2': 'MF',
    'iso3': 'MAF',
    'phone_code': '1 599'
  },
  {
    'nombre': 'San Pedro y Miquelón',
    'iso2': 'PM',
    'iso3': 'SPM',
    'phone_code': '508'
  },
  {
    'nombre': 'San Vicente y las Granadinas',
    'iso2': 'VC',
    'iso3': 'VCT',
    'phone_code': '1 784'
  },
  {
    'nombre': 'Santa Elena',
    'iso2': 'SH',
    'iso3': 'SHN',
    'phone_code': '290'
  },
  {
    'nombre': 'Santa Lucía',
    'iso2': 'LC',
    'iso3': 'LCA',
    'phone_code': '1 758'
  },
  {
    'nombre': 'Santo Tomé y Príncipe',
    'iso2': 'ST',
    'iso3': 'STP',
    'phone_code': '239'
  },
  {
    'nombre': 'Senegal',
    'iso2': 'SN',
    'iso3': 'SEN',
    'phone_code': '221'
  },
  {
    'nombre': 'Serbia',
    'iso2': 'RS',
    'iso3': 'SRB',
    'phone_code': '381'
  },
  {
    'nombre': 'Seychelles',
    'iso2': 'SC',
    'iso3': 'SYC',
    'phone_code': '248'
  },
  {
    'nombre': 'Sierra Leona',
    'iso2': 'SL',
    'iso3': 'SLE',
    'phone_code': '232'
  },
  {
    'nombre': 'Singapur',
    'iso2': 'SG',
    'iso3': 'SGP',
    'phone_code': '65'
  },
  {
    'nombre': 'Siria',
    'iso2': 'SY',
    'iso3': 'SYR',
    'phone_code': '963'
  },
  {
    'nombre': 'Somalia',
    'iso2': 'SO',
    'iso3': 'SOM',
    'phone_code': '252'
  },
  {
    'nombre': 'Sri lanka',
    'iso2': 'LK',
    'iso3': 'LKA',
    'phone_code': '94'
  },
  {
    'nombre': 'Sudáfrica',
    'iso2': 'ZA',
    'iso3': 'ZAF',
    'phone_code': '27'
  },
  {
    'nombre': 'Sudán',
    'iso2': 'SD',
    'iso3': 'SDN',
    'phone_code': '249'
  },
  {
    'nombre': 'Suecia',
    'iso2': 'SE',
    'iso3': 'SWE',
    'phone_code': '46'
  },
  {
    'nombre': 'Suiza',
    'iso2': 'CH',
    'iso3': 'CHE',
    'phone_code': '41'
  },
  {
    'nombre': 'Surinám',
    'iso2': 'SR',
    'iso3': 'SUR',
    'phone_code': '597'
  },
  {
    'nombre': 'Svalbard y Jan Mayen',
    'iso2': 'SJ',
    'iso3': 'SJM',
    'phone_code': ''
  },
  {
    'nombre': 'Swazilandia',
    'iso2': 'SZ',
    'iso3': 'SWZ',
    'phone_code': '268'
  },
  {
    'nombre': 'Tadjikistán',
    'iso2': 'TJ',
    'iso3': 'TJK',
    'phone_code': '992'
  },
  {
    'nombre': 'Tailandia',
    'iso2': 'TH',
    'iso3': 'THA',
    'phone_code': '66'
  },
  {
    'nombre': 'Taiwán',
    'iso2': 'TW',
    'iso3': 'TWN',
    'phone_code': '886'
  },
  {
    'nombre': 'Tanzania',
    'iso2': 'TZ',
    'iso3': 'TZA',
    'phone_code': '255'
  },
  {
    'nombre': 'Territorio Británico del Océano Índico',
    'iso2': 'IO',
    'iso3': 'IOT',
    'phone_code': ''
  },
  {
    'nombre': 'Territorios Australes y Antárticas Franceses',
    'iso2': 'TF',
    'iso3': 'ATF',
    'phone_code': ''
  },
  {
    'nombre': 'Timor Oriental',
    'iso2': 'TL',
    'iso3': 'TLS',
    'phone_code': '670'
  },
  {
    'nombre': 'Togo',
    'iso2': 'TG',
    'iso3': 'TGO',
    'phone_code': '228'
  },
  {
    'nombre': 'Tokelau',
    'iso2': 'TK',
    'iso3': 'TKL',
    'phone_code': '690'
  },
  {
    'nombre': 'Tonga',
    'iso2': 'TO',
    'iso3': 'TON',
    'phone_code': '676'
  },
  {
    'nombre': 'Trinidad y Tobago',
    'iso2': 'TT',
    'iso3': 'TTO',
    'phone_code': '1 868'
  },
  {
    'nombre': 'Tunez',
    'iso2': 'TN',
    'iso3': 'TUN',
    'phone_code': '216'
  },
  {
    'nombre': 'Turkmenistán',
    'iso2': 'TM',
    'iso3': 'TKM',
    'phone_code': '993'
  },
  {
    'nombre': 'Turquía',
    'iso2': 'TR',
    'iso3': 'TUR',
    'phone_code': '90'
  },
  {
    'nombre': 'Tuvalu',
    'iso2': 'TV',
    'iso3': 'TUV',
    'phone_code': '688'
  },
  {
    'nombre': 'Ucrania',
    'iso2': 'UA',
    'iso3': 'UKR',
    'phone_code': '380'
  },
  {
    'nombre': 'Uganda',
    'iso2': 'UG',
    'iso3': 'UGA',
    'phone_code': '256'
  },
  {
    'nombre': 'Uruguay',
    'iso2': 'UY',
    'iso3': 'URY',
    'phone_code': '598'
  },
  {
    'nombre': 'Uzbekistán',
    'iso2': 'UZ',
    'iso3': 'UZB',
    'phone_code': '998'
  },
  {
    'nombre': 'Vanuatu',
    'iso2': 'VU',
    'iso3': 'VUT',
    'phone_code': '678'
  },
  {
    'nombre': 'Venezuela',
    'iso2': 'VE',
    'iso3': 'VEN',
    'phone_code': '58'
  },
  {
    'nombre': 'Vietnam',
    'iso2': 'VN',
    'iso3': 'VNM',
    'phone_code': '84'
  },
  {
    'nombre': 'Wallis y Futuna',
    'iso2': 'WF',
    'iso3': 'WLF',
    'phone_code': '681'
  },
  {
    'nombre': 'Yemen',
    'iso2': 'YE',
    'iso3': 'YEM',
    'phone_code': '967'
  },
  {
    'nombre': 'Yibuti',
    'iso2': 'DJ',
    'iso3': 'DJI',
    'phone_code': '253'
  },
  {
    'nombre': 'Zambia',
    'iso2': 'ZM',
    'iso3': 'ZMB',
    'phone_code': '260'
  },
  {
    'nombre': 'Zimbabue',
    'iso2': 'ZW',
    'iso3': 'ZWE',
    'phone_code': '263'
  }
]
